import * as types from './types'

export default {
  [types.SET_BROKEN_LINKS](state, data) {
    state.brokenLinks = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.brokenLinks = data
      }
    }
    console.log('Got Broken Links', state.brokenLinks)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/repair-links/mutations.js